import React from 'react';
import { motion } from 'framer-motion';
export function TheProblem() {
  return <section className="py-20 px-6 bg-brand-cream" data-id="element-138">
      <div className="max-w-3xl mx-auto" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-140">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-brown mb-8 text-center" data-id="element-141">
            El verdadero problema
          </h2>

          <div className="space-y-6 text-lg text-brand-textLight leading-relaxed" data-id="element-142">
            <p data-id="element-143">
              La privación del sueño no es solo cansancio; es una forma de
              tortura que erosiona tu paciencia, tu matrimonio y tu salud
              mental.
            </p>
            <p data-id="element-144">
              El problema es que la mayoría de los consejos que recibes en los
              grupos de padres o en internet se basan en teorías agotadoras: o
              dejas que tu bebé llore hasta el cansancio (rompiendo tu corazón),
              o te conviertes en una "almohada humana" que no puede despegarse
              de él en toda la noche.
            </p>
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-brand-brown mt-8" data-id="element-145">
              <p className="font-medium text-brand-text" data-id="element-146">
                Ninguno de estos métodos ataca la raíz biológica: el exceso de
                cortisol (la hormona del estrés) en la sangre de tu bebé.{' '}
                <strong className="text-brand-brown" data-id="element-147">
                  Mientras su cuerpo esté en modo "alerta", ninguna rutina de
                  baño con lavanda lo va a dormir.
                </strong>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}